<template>
  <div id="severePane" :style="stylePane">
    <slider 
      :display="sliderDisplay"
      :max="max" 
      :min="min"
      :step="step"
      :marks="marks"
      :list="severeList"
      @slider-step="onSliderChange"
      @play-step="onSliderChange"
      @play-stopped="onSliderEnd"
    />
    <div id="severeEmptyPane" :style="styleEmptyPane">
        <span class="badge">强天气预警内容为空</span>
    </div>
  </div>
</template>

<script>
import { computed } from 'vue'
import { useStore } from 'vuex'
import api from '../modules/api'
import L from '../modules/leaflet'
import Slider from '../components/control/Slider.vue'

const PANE_ID = "severe"
const PANE_LAYER = "severe-layer"

export default {
  setup() {
    const store = useStore()
    const currentPaneId = computed(() => store.state.currentPaneId)
    const map = computed(() => store.state.map)
    return {
      currentPaneId,
      map
    }
  },

  components: {
    Slider,
  },

  data() {
    return {
      severeList: [],
      status: 'loading',
      min: 0,
      max: 20,
      step: 1,
      marks: {
        0: "00:00",
        10: "01:00",
        20: "02:00"
      }
    }
  },

  computed: {
    stylePane() {
      return this.currentPaneId != PANE_ID ? { "display": "none" } : {}
    },

    styleEmptyPane() {
      return this.status != 'empty' ? { "display": "none" } : {}
    },

    sliderDisplay() {
      return this.status != 'list' ? "none": ""
    }

  },

  mounted() {
    this.init()
  },

  beforeUnmount() {
    this.clear()
  },

  methods: {
    onSliderChange(value) {
      this.setStep(value)
    },

    onSliderEnd() {
      this.setStep(this.$data.min)
    },

    getMap() {
      return this.$store.state.map
    },

    getIcon(eventType) {
      if (eventType == "lightning") {
        return {icon: "wi-lightning", markerColor: "orange", text: "雷"}
      } else if (eventType == "wind") {
        return {icon: "wi-sandstorm", markerColor: "blue", text: "风"}
      } else if (eventType == "hail") {
        return {icon: "wi-stars", markerColor: "red", text: "雹"}
      } 
      return {icon: "wi-lightning", markerColor: "yellow", text: "雷"}
    },

    setStep(index) {
      if (this.currentPaneId == PANE_ID) {
        const map = this.$store.state.map
        map.replaceLayer(PANE_LAYER, this.createEventLayer(this.severeList[index]))
      }
    },

    createEventLayer(row) {
      const eventMarks = row.event.map((event) => {
        const icon = this.getIcon(event.type)
        const opt = {
          closeButton: false,
          closeOnClick: false,
          minWidth: 20,
          maxWidth: 400,
          offset: L.point(0, 10),
          autoPan: false,
          className: 'severe-popup-outter-tiny severe-popup-outter-' + icon.markerColor
        }
        return L.popup(opt)
          .setLatLng(L.latLng(event.lat, event.lon))
          .setContent(`<div class='severe-popup text'>${icon.text}</div>`)
      })

      return L.layerGroup(eventMarks)
    },

    init() {
      console.log("    > loading pane .....", PANE_ID)
      api.fetchSevere().then((data) => {
        if (data.length == 0) {
          this.status = 'empty'
        } else {
          this.status = 'list'
          this.severeList = data;
          const length = data.length

          // set parameters for slider
          this.$data.max = length - 1
          const marks = {}

          for(let i = 0; i <= length - 1; i = i + 1) {
            marks[i] = {
              label: i == 0 || i == length - 1 ? data[i].display.split(' ')[1]: "'"
            }
          }
          this.$data.marks = marks
          this.setStep(0)
        }
      })
    },

    clear() {
      console.log("    > closing pane .....", PANE_ID)
      const map = this.$store.state.map
      map.removeLayer(PANE_LAYER)
    }
  }
}


</script>


<style>

#severePane {
  z-index: 31; 
  width: 650px; 
  font-size: 10px;
  background-color: #fff!important;
  border-radius: .25rem!important;
  position: absolute!important;
  left: 50%!important;
  transform: translateX(-50%)!important;
  box-shadow: 0 1rem 3rem rgba(0,0,0,.175)!important;
  bottom:0;
  margin-bottom: .5rem!important;
  font-size: 10px;
}

#severeEmptyPane {
  z-index: 31; opacity: 0.7;
  position: absolute;
  bottom: 0;
  text-align: center;
  padding: .5rem;
  margin-bottom: 0.5rem;
  left: 50%;
  transform: translateX(-50%)!important;
}

#severeEmptyPane .badge {
  background-color: #ffc107;
  color: #212529;
  display: inline-block;
  padding: 0.5em 0.8em;
  font-size: 3.4em;
  font-weight: 700;
  line-height: 1;
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: .25rem;
}

@media (max-width: 780px) {
  #severePane { width: 350px; }
  #severeEmptyPane .badge {font-size: 2.5em;}
}

.severe-popup-outter-tiny .leaflet-popup-content-wrapper {padding: 0px; border-radius: 4px; }
.severe-popup-outter-tiny .leaflet-popup-content{margin:1px; width:auto;}
.severe-popup-outter-tiny .leaflet-popup-tip-container{display: none;}
.severe-popup-outter-tiny .text {color: #fff; cursor:pointer;font-size:14px;padding:0px;margin:5px;}
.severe-popup-outter-tiny .alarm-popup{text-align: center;}

.alarm-big .severe-popup-outter-tiny .text {
  color: #fff;cursor:pointer;font-size:14px;padding:5px;margin:0px;}

.severe-popup-outter-red .leaflet-popup-content-wrapper {background-color: #F23030;}
.severe-popup-outter-orange .leaflet-popup-content-wrapper {background-color: #FF9403;}
.severe-popup-outter-blue .leaflet-popup-content-wrapper {background-color: #497DF5;}


</style>